import { Box } from '@mui/material';
import Button from '@mui/material/Button';

import { selectAuth } from '~modules/auth/store/auth-selectors';
import { signOutThunk } from '~modules/auth/store/auth-thunks';

import { useAppDispatch, useAppSelector } from '~system/store/configure-store';

import { SidebarItem } from '~components/layout/sidebar/components/sidebar-item';
import { AppIcon } from '~components/shared/app-icon/app-icon';

import { useConfirmationModal } from '~hooks/use-confirmation-modal';
import { useMobileMenu } from '~hooks/use-mobile-menu';

import { ROUTES } from '~app/router/routes';

import { ReactComponent as IconClose } from '~assets/icons/icon-close.svg';
import { ReactComponent as IconLogout } from '~assets/icons/icon-log-out.svg';

export const LessorSidebarFooter = () => {
  const { closeMenu } = useMobileMenu();
  const dispatch = useAppDispatch();
  const { openConfirmationModal } = useConfirmationModal();
  const auth = useAppSelector(selectAuth);

  const handleClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();

    openConfirmationModal({
      title: 'Вихід з акаунту',
      content: 'Ви впевнені що хочете вийти з акаунту?',
      confirmButton: (
        <Button
          variant={'outlined'}
          startIcon={<AppIcon component={IconLogout} size={20} />}
          color={'error'}
          loading={auth.isLoading}
          sx={{ width: { xs: '100%', sm: 'auto' } }}
        >
          Вийти
        </Button>
      ),
      cancelButton: (
        <Button
          sx={{ width: { xs: '100%', sm: 'auto' } }}
          startIcon={<AppIcon component={IconClose} size={22} />}
        >
          Скасувати
        </Button>
      ),
      onConfirm: () => {
        dispatch(signOutThunk());
        closeMenu();
      },
    });
  };

  return (
    <Box
      sx={{
        cursor: 'pointer',
        borderTop: '1px solid',
        borderColor: 'fog.90',

        boxShadow: '0 -6px 12px -8px rgba(0, 0, 0, 0.04)',
        backgroundColor: 'neutral.100', // важно, чтобы тень читалась
      }}
    >
      <SidebarItem
        label={'Вийти'}
        to={ROUTES.LOGIN}
        onClick={handleClick}
        icon={IconLogout}
        sx={{
          '&:hover': {
            backgroundColor: 'red.10',
            color: 'red.125',
          },
        }}
      />
    </Box>
  );
};
